import React, { Component } from 'react';

import Sidenav from './Sidenav';
import '../css/App.css';
import axios from 'axios';
import API from '../config_api'
import Loader from '../component/Loader';
import IdleTimerLogout from './IdleTimerLogout';



class MyAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading:false
        };

    }
    componentWillMount() {
        if (!localStorage.getItem('token')) {
            this.props.history.push('/');
        }
        this.setState({
            loading:true
        })
        let formData = new FormData();
        formData.append('user_id', localStorage.getItem('token'))

      axios({
        method: 'post',
        url: API.MyAccount,
        data:formData,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        mode: 'no-cors',
    })
        .then(res => {
            if (res.data.status === 'success') {
                this.setState({
                    data:res.data.data,
                    loading:false
                })

            } else {
                alert(res.data.message);
                this.setState({
                    loading:false
                })
            }
        });
    }

    render() {
        return (<div className="" >
           
           <Sidenav type={'second'} url={'/dashboard'}/>
            <div className="container">
            <div style={{position:'fixed',left:0,right:0,zIndex:1,background:'#F8F9FE'}}>
                        <div className="container">
                        <div className="row">
                           
                            <div className="col-md-12 text-center" style={{ padding: 15 }}>
                                <h5 className="size-text">My Account</h5>
                            </div>
                        </div>
                      </div>
                      </div>
                      <div style={{height:60}}></div>
                <div className="row">
                    <div className="col s12 account">
                    <p>Employee ID : {this.state.data.employee_id}</p>
                    <p>Email ID : {this.state.data.email}</p>
                    <p>First Name : {this.state.data.name}</p>
                    <p>Last Name :{this.state.data.lastname}</p>
                    <p>Phone :{this.state.data.phone}</p>
                    <p>Location :{this.state.data.location}</p>
                    <p>Division :{this.state.data.division}</p>
                    <p>Department :{this.state.data.department}</p>
                    </div>
                </div>
            </div>
            {this.state.loading && <Loader/> }
            
        </div>
        );
    }
}

export default MyAccount;